import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { JobUtils } from '@app/shared/utils/job-utils';
import { DocumentSegment } from '@app/shared/models/documentSegment';
import { Job } from '@app/shared/models/job';
import { User } from '@app/shared/models/user';
import { Offer } from '@app/shared/models/offer';
import { OfferTemplate } from '@app/shared/models/offerTemplate';
import { OfferAllocation } from '@app/shared/models/offerAllocation';
import { NGXLogger } from 'ngx-logger';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/app.states';
import { MoveAllocation, RemoveAllocation } from '@app/store/actions/offer.actions';
import { Subscription } from 'rxjs/Subscription';
import { PermissionsService } from "@app/core/services/permissions.service";

@Component({
  selector: 'app-allocation-editor',
  templateUrl: './allocation-editor.component.html',
  styleUrls: ['./allocation-editor.component.scss']
})
export class AllocationEditorComponent implements OnInit {

  private permissionSubscription:Subscription;
  private _job:Job;
  private _documentSegment:DocumentSegment;
  private _user:User;

  @ViewChild('psb')
  private psb : any;

  @Input()
  public set job(val:Job){
    this._job = val;
  }

  public get job():Job{
    return this._job;
  }

  @Input()
  public set user(val:User){
    this._user = val;
  }

  public get user():User{
    return this._user;
  }


  @Input()
  public set documentSegment(val:DocumentSegment){
    this._documentSegment = val;
  }

  public get documentSegment():DocumentSegment{
    return this._documentSegment;
  }

  constructor(public dialogRef: MatDialogRef<AllocationEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    public jobUtils:JobUtils,
    private logger:NGXLogger,
    private store:Store<AppState>,
    private workflow:PermissionsService,
  ) {
    this.user = data.user;
    this.job = data.job;
    this.documentSegment = data.documentSegment;
  }

  ngOnInit() {
  }

  getOfferTemplate(val:Offer):OfferTemplate{
      // find the view template in the document segments public offers
      var offer;
      let template:OfferTemplate;
      if(val){
        this.documentSegment.publicOffers.map(o => {
          if(o.uuid === val.uuid)
            offer = o;
        })

        if(offer && offer.offerViews && offer.offerViews.length){
          template = offer.offerViews[0].viewTemplate;
        }
      }

      return template;
  }


  canDragAllocation(allocation:OfferAllocation):boolean{

    var canDrag = true;
    this.permissionSubscription = this.workflow.checkAuthorization(["allocation","move"]).subscribe(authorized => {

      const isAdmin = this.jobUtils.userIsAdmin(this.user);

      if(!isAdmin)
        canDrag = this.jobUtils.arraysHaveMatch(this.user.departments,[allocation.department]).length?true:false;

      // if we are an admin we can drag
      if(isAdmin){
        canDrag = true;
        authorized = true;
      }

      if(this.jobUtils.isLocked(allocation.publicOffers[0]) || this.jobUtils.isLocked(this.documentSegment) || !authorized)
        canDrag = false;

    });

    return canDrag;
  }


  onAllocationDrop(event:any, oa:OfferAllocation, ds:DocumentSegment):void{

    //let o = event.dragData.offer;
    let targetOA = oa;
    let data = event.dragData;
    var payload = {allocation:data,position:oa.pagePosition, allocations:this._documentSegment.offerAllocation}

    // if this is not the current allocation
    if(data.pagePosition !== oa.pagePosition)
      this.store.dispatch(new MoveAllocation(payload));
  }

  onAllocationDrag(event:any):void{
    const offset = this.psb.elementRef.nativeElement.offsetHeight + this.psb.elementRef.nativeElement.offsetTop;
    const rect = this.psb.elementRef.nativeElement.getBoundingClientRect();

    let top = this.psb.directiveRef.elementRef.nativeElement.scrollTop;

    if(event.screenY < (rect.top + this.psb.elementRef.nativeElement.offsetTop) && top > 0){
      top -= 5;
      this.psb.directiveRef.scrollToY(top,0);
    }
    const rail = this.psb.elementRef.nativeElement.querySelector('.ps__rail-y');
    const thumb = this.psb.elementRef.nativeElement.querySelector('.ps__thumb-y');

    let atBottom = (parseInt(rail.style.height, 10) - parseInt(thumb.style.top, 10) - parseInt(thumb.style.height, 10)) === 0?true:false;
    if(event.screenY > (rect.top + this.psb.elementRef.nativeElement.offsetTop + rect.height) && !atBottom){
      top += 5;
      this.psb.directiveRef.scrollToY(top,0);
    }

  }
  removeAllocation(val:OfferAllocation):void{
    const payload = {allocation:val, allocations:this._documentSegment.offerAllocation, documentSegment:this._documentSegment};
    this.store.dispatch(new RemoveAllocation(payload))
  }

  ngOnDestroy():void{
    if(this.permissionSubscription)
      this.permissionSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/allocation-editor/allocation-editor.component.ts